export default __webpack_public_path__ + "static/cer-7-b2617de57ef8dee952392a9d29908bcd.webp";